export default __webpack_public_path__ + "static/media/GreenDesiredJob.bb45c667.svg";